import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReport = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_892_19080",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_892_19080)",
		children: /* @__PURE__ */ _jsx("path", { d: "M12 16.7115C12.2288 16.7115 12.4207 16.6341 12.5755 16.4793C12.7303 16.3245 12.8077 16.1327 12.8077 15.9038C12.8077 15.675 12.7303 15.4832 12.5755 15.3284C12.4207 15.1735 12.2288 15.0961 12 15.0961C11.7711 15.0961 11.5793 15.1735 11.4245 15.3284C11.2697 15.4832 11.1923 15.675 11.1923 15.9038C11.1923 16.1327 11.2697 16.3245 11.4245 16.4793C11.5793 16.6341 11.7711 16.7115 12 16.7115ZM11.25 13.2308H12.75V7.1923H11.25V13.2308ZM8.46153 20.5L3.5 15.543V8.46153L8.457 3.5H15.5384L20.5 8.457V15.5384L15.543 20.5H8.46153ZM9.09998 19H14.9L19 14.9V9.09998L14.9 4.99997H9.09998L4.99997 9.09998V14.9L9.09998 19Z" })
	})]
});
export default SvgReport;
